<template>
  <div>
    <div class="mpf-panel">
      <h1 class="mpf-panel__title">{{ panelTitle ?? 'Appointment cancelled' }}</h1>
      <div class="mpf-panel__body">Your appointment has been cancelled.</div>
    </div>

    <MpfSummaryList v-if="summaryRows.length" :rows="summaryRows" />

    <p>If you still need to be seen, book another appointment or contact your GP practice.</p>

    <p v-if="!isOpenInNhsApp">You may now close this window.</p>
  </div>
</template>

<script setup lang="ts">
  import { storeToRefs } from 'pinia';

  import MpfSummaryList from '../components/MpfSummaryList/MpfSummaryList.vue';
  import { useAppointmentCancellationStore } from '../../stores/useAppointmentCancellationStore';
  import { useNhsAppStore } from '../../stores/useNhsAppStore';
  import { useRouteMeta } from '../composables/useRouteMeta';
  import { useAppointmentSummaryRows } from '../composables/useAppointmentSummaryRows';

  const { panelTitle } = useRouteMeta();

  // Direct entry is not bounced: landing here cold shows the confirmation
  // without a summary rather than an error.
  const store = useAppointmentCancellationStore();
  const { appointment } = storeToRefs(store);
  const { summaryRows } = useAppointmentSummaryRows(appointment);

  const { isOpenInNhsApp } = storeToRefs(useNhsAppStore());
</script>
